import React from "react"

const SectionHero = () => (
  <section className="hero2 sub-hero">
    <div className="wrap two">
      <div>
        <h1>Prepare for CJR-X before the first performance year begins</h1>
        <p className="lede">
          CJR-X is mandatory for most hospitals from January 1, 2028, with
          two-sided risk from year one. We show where you stand against your
          region now.
        </p>
      </div>
      <div className="glance2 cjrx">
        <div className="g-head">
          <span>CJR-X at a glance</span>
          <em>Starts Jan 1, 2028</em>
        </div>
        <div className="g-facts">
          <div>
            <b>2,000+</b>
            <span>hospitals nationwide</span>
          </div>
          <div>
            <b>90</b>
            <span>days after discharge</span>
          </div>
          <div>
            <b>Year 1</b>
            <span>two-sided risk</span>
          </div>
        </div>
        <dl className="g-rows">
          <dt>Who</dt>
          <dd>
            Acute care hospitals paid under both the IPPS and OPPS. Excludes
            TEAM participants and Maryland.
          </dd>
          <dt>Episodes</dt>
          <dd>
            Hip, knee, and ankle replacement. MS-DRGs 469, 470, 521, 522 and
            HCPCS 27130, 27447.
          </dd>
          <dt>Risk</dt>
          <dd>
            Losses capped at 20% of target, or 5% for safety net, rural, and
            certain other hospitals.
          </dd>
        </dl>
      </div>
    </div>
  </section>
)

export default SectionHero
